import { render, staticRenderFns } from "./JdiDoNot.vue?vue&type=template&id=130b8bfe&"
import script from "./JdiDoNot.vue?vue&type=script&lang=ts&"
export * from "./JdiDoNot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports